// extracted by mini-css-extract-plugin
export default {"questionStyle":"Feedback_questionStyle__by8Qh","showMoreLink":"Feedback_showMoreLink__zGQhn"};